module.exports = __webpack_public_path__ + "static/canon-r5-f8487d7856d6b8b553e333f1f453282b.jpg";